import classNames from 'classnames'
import React from 'react'

export interface ProgressProps {
    current: number
    items: ProgressItemProps[]
    className?: string
}

export interface ProgressItemProps {
    label: string
}

export const Progress = (props: ProgressProps): JSX.Element => {
    const className: string = classNames('progress', props.className)

    return (
        <div className={className}>
            <ul className="progress__list">
                {props.items.map((item: ProgressItemProps, index: number) => {
                    const itemClassName: string = classNames(
                        'progress__item',
                        props.current > index + 1 && 'progress__item--previous',
                        props.current === index + 1 && 'progress__item--current',
                        props.current < index + 1 && 'progress__item--next',
                    )

                    return (
                        <li className={itemClassName} key={index}>
                            <span className="progress__bullet text-tiny bold">{index + 1}</span>
                            <span className="progress__label text-small">{item.label}</span>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
